import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';

import { PRIMENG_CONFIG } from './core/initializers/primeng.config';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { tenantInterceptor } from './core/interceptors/tenant.interceptor';
import { routes } from './app.routes';
import { ThemeService } from './core/services/theme.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      // Outermost first: error → tenant → auth → backend. Auth sees 401 before error
      // toasts; retries still pass through tenant (headers) and error (toasts).
      withInterceptors([errorInterceptor, tenantInterceptor, authInterceptor]),
    ),
    providePrimeNG(PRIMENG_CONFIG),
    MessageService,
    DialogService,
    ThemeService,
  ],
};
